/* eslint-disable no-console */
function info(message) {
  console.info(message);
}

function log(message) {
  console.error(message);
}

function debug(message) {
  if (process.env.NODE_ENV !== 'production') {
    console.debug(message);
  }
}

function error(message) {
  console.error(message);
}

const methods = { debug, error, info, log };

export default methods;
